<div class="fixed inset-0 z-[9999] bg-[rgba(0,0,0,0.59)] flex items-center justify-center">
  <div class="bg-white rounded-lg p-6 w-[90vw] max-w-[270px] h-[200px] max-h-[90vh] flex flex-col justify-center items-center">
    <mat-progress-spinner class="custom-spinner" mode="indeterminate" diameter="80" strokeWidth="4"></mat-progress-spinner>
  </div>
</div>
